<template>
  <div id="app-header">
    <el-breadcrumb separator="/" style="line-height: inherit">
      <template v-for="(value, index) in currentRoute.matched">
        <el-breadcrumb-item :to="value.path">{{value.name}}</el-breadcrumb-item>
      </template>
    </el-breadcrumb>
  </div>
</template>

<script>
export default {
  name: "app-header",
  computed: {
    currentRoute() {
      return this.$route
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/layout/components/AppHeader.vue